module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/half-heart-bbdb9ce45877932a2e465b501fc3539c.svg";